import { useEffect, useState } from 'react';
import { message } from 'antd';
import { IListItem, IServerProps, ITabActivityKey } from '@pro/activity/testerClub/interface';
import { useStore } from 'base/store';
import { getEarlyAccessConfig, participateTrial } from '@pro/activity/testerClub/services';
import { RouteEnum } from 'pro/config/routers'
import { IUseShareLink, useShareLink } from 'base/utils/useShareLink'
import { trackPageView } from 'base/utils/tracker'
import Message from '@base/lib/Message';
import { useTrans } from 'base/utils/i18n'

export type IShowLists = {
    onGoing: IListItem[];
    completed: IListItem[]
}

export type IUseEarlyAccess = {
    showLists?: IShowLists;
    wholeList?: IListItem[];
    tabActivityKey: ITabActivityKey;
    onChangeTab: (key: ITabActivityKey) => void;
    onSubmitApply: (product: IListItem) => Promise<void>;
    share?: IUseShareLink;
}

type IProps = {
    serverProps: IServerProps
}

export function useEarlyAccess(props: IProps): IUseEarlyAccess {
    const {
        rootStore: { state: { host } },
    } = useStore();
    const { t } = useTrans();

    const { list: listProps = [] } = props.serverProps || {}

    const [showLists, setShowLists] = useState<IShowLists>();
    const [tabActivityKey, setTabActivityKey] = useState<ITabActivityKey>('onGoing')
    
    const shareUrl = `https://${host}${RouteEnum.TesterClub}`;

    // t()中的链接替换转码问题、外部替换
    const title = t('web_shop_activity_early_access_rules_desc7')?.replace('{{link}}', shareUrl)
    const share = useShareLink({
        url: shareUrl,
        title: title
    });

    const onChangeTab = (key) => {
        setTabActivityKey(key)
    }

    const showListHandle = (list: IListItem[]) => {
        const _showLists: IShowLists = {
            onGoing: [],
            completed: []
        }
        for (let i = 0; i < list.length; i++) {
            const item = list[i] || {}
            const { end, endTime = 0 } = item

            const currentTime = Math.floor(Date.now() / 1000);

            if (end || (+endTime < currentTime)) {
                _showLists.completed.push(item)

            } else {
                _showLists.onGoing.push(item)
            }
        }

        if(!_showLists.onGoing.length) {
            onChangeTab('completed')
        }

        setShowLists(_showLists)
    }

    const getConfigs = async () => {
        try {
            const res = await getEarlyAccessConfig()

            showListHandle(res.list)

        } catch (err) {
            Message.error(err.message)
        }
    }

    const onSubmitApply = async (product: IListItem) => {
        if (!product.activityGid) {
            Message.error('miss activityGid')
            return
        }
        try {
            const res = await participateTrial({
                activityGid: product.activityGid
            })
            if (!!res.success) {
                getConfigs().then()
            }

        } catch (err) {
            Message.error(err.message)
        }
    }

    useEffect(()=> {
        trackPageView();
        showListHandle(listProps)
    }, [])

    return {
        share,
        showLists,
        wholeList: listProps,
        tabActivityKey,
        onChangeTab,
        onSubmitApply
    }
}